import Decimal from "decimal.js";
import { createRevisionClassResource } from "../../revision";
import { ResourceItem } from "../ResourceItem";
import {
  apiField,
  constructFromApiData,
  decimalApiField,
  getApiPostData,
  getDiff,
  itemApiField,
  revisionApiField,
} from "../ResourceItemMetadata";
import { RevisionItem } from "../RevisionItem";
import { Ingredient } from "./Ingredient";

class NestedRecipe extends ResourceItem {
  @apiField({
    inputTransform: (ingredients) =>
      ingredients.map((s: any) => new Ingredient(s)),
    outputTransform: (ingredients) =>
      ingredients.map((s: any) => s.getPostData()),
  })
  ingredients: Ingredient[] = [];
  @decimalApiField()
  defaultMassKg: Decimal = new Decimal(1000);

  constructor(data: any) {
    super(data);

    if (data) {
      constructFromApiData(this, data);
    }
  }
}

export class ProductionRecipe extends RevisionItem {
  @apiField()
  name = "";

  @itemApiField(NestedRecipe)
  recipe: NestedRecipe | null = null;
  @revisionApiField()
  product: RevisionItem | null = null;

  @decimalApiField()
  specificWeight: Decimal = new Decimal(0);

  @apiField()
  npType = "";
  @decimalApiField()
  npAmount: Decimal = new Decimal(0);

  @apiField()
  notes = "";

  constructor(data: any) {
    super(data);
    if (data) constructFromApiData(this, data);
  }

  getPostData() {
    return {
      ...super.getPostData(),
      ...getApiPostData(this),
    };
  }

  getDiff(other: this) {
    return {
      ...getDiff(this, other),
    };
  }
}

export const productionRecipeResource = createRevisionClassResource(
  "plm/productionRecipe/",
  ProductionRecipe,
);
